import type { SVGProps } from 'react';

export const Calendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    viewBox="0 0 14.9 16"
    x="0px"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'calendar'}</title>
    <g>
      <path
        d="M11.5,4c0.6,0,1.1-0.5,1.1-1.1V1.1c0-0.6-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1v1.7
        		C10.3,3.5,10.8,4,11.5,4z M13.8,1.7h-0.6v1.7c0,0.6-0.5,1.1-1.1,1.1h-1.1c-0.6,0-1.1-0.5-1.1-1.1V1.7H5.2v1.7
        		c0,0.6-0.5,1.1-1.1,1.1H2.9c-0.6,0-1.1-0.5-1.1-1.1V1.7H1.1C0.5,1.7,0,2.2,0,2.9v12C0,15.5,0.5,16,1.1,16h12.6
        		c0.6,0,1.1-0.5,1.1-1.1v-12C14.9,2.2,14.4,1.7,13.8,1.7z M13.8,14.9H1.1V5.7h12.6V14.9z M3.4,4c0.6,0,1.1-0.5,1.1-1.1V1.1
        		C4.6,0.5,4.1,0,3.4,0C2.8,0,2.3,0.5,2.3,1.1v1.7C2.3,3.5,2.8,4,3.4,4z"
      />
    </g>
  </svg>
);
